import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-brand-dark text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-brand-gray-dark rounded-2xl p-8 md:p-12">
          <div className="flex flex-col md:flex-row items-start justify-between mb-12">
            <div className="flex items-center space-x-4">
              <img src="/icon.png" alt="Universal Pays Logo" className="w-12 h-12" />
              <h1 className="text-4xl font-bold gradient-text">Privacy Policy</h1>
            </div>
            <Link 
              to="/"
              className="text-gray-400 hover:text-brand-blue transition-colors duration-300 text-sm"
            >
              ← Back to Home
            </Link>
          </div>

          <div className="space-y-8">
            <div className="border-b border-brand-gray pb-6">
              <h2 className="text-2xl font-bold mb-4">1. Information We Collect</h2>
              <ul className="list-disc list-inside text-gray-300 space-y-2">
                <li>Personal information (name, email, phone number)</li>
                <li>Transaction data</li>
                <li>Device information</li>
                <li>Cookies and similar technologies</li>
              </ul>
            </div>

            <div className="border-b border-brand-gray pb-6">
              <h2 className="text-2xl font-bold mb-4">2. How We Use Your Information</h2>
              <ul className="list-disc list-inside text-gray-300 space-y-2">
                <li>To provide and improve our services</li>
                <li>To process transactions</li>
                <li>To communicate with you</li>
                <li>To comply with legal obligations</li>
              </ul>
            </div>

            <div className="border-b border-brand-gray pb-6">
              <h2 className="text-2xl font-bold mb-4">3. Data Security</h2>
              <p className="text-gray-300 mb-4">
                We implement industry-standard security measures to protect your personal information, including:
              </p>
              <ul className="list-disc list-inside text-gray-300 space-y-2">
                <li>Encryption (AES-256)</li>
                <li>Secure data centers</li>
                <li>Regular security audits</li>
              </ul>
            </div>

            <div className="border-b border-brand-gray pb-6">
              <h2 className="text-2xl font-bold mb-4">4. Your Rights</h2>
              <ul className="list-disc list-inside text-gray-300 space-y-2">
                <li>Right to access your data</li>
                <li>Right to rectify incorrect information</li>
                <li>Right to delete your data</li>
                <li>Right to object to processing</li>
              </ul>
            </div>

            <div className="border-b border-brand-gray pb-6">
              <h2 className="text-2xl font-bold mb-4">5. Cookies</h2>
              <p className="text-gray-300">
                We use cookies to enhance your experience. You can manage your cookie preferences through your browser settings.
              </p>
            </div>

            <div className="border-b border-brand-gray pb-6">
              <h2 className="text-2xl font-bold mb-4">6. Third Parties</h2>
              <p className="text-gray-300">
                We may share your information with service providers who assist us in operating our business. All third parties are required to maintain the confidentiality of your information.
              </p>
            </div>

            <div className="border-b border-brand-gray pb-6">
              <h2 className="text-2xl font-bold mb-4">7. Children's Privacy</h2>
              <p className="text-gray-300">
                Our services are not intended for children under 18 years of age. We do not knowingly collect personal information from children.
              </p>
            </div>

            <div className="border-b border-brand-gray pb-6">
              <h2 className="text-2xl font-bold mb-4">8. Updates to Privacy Policy</h2>
              <p className="text-gray-300">
                We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4">9. Contact Us</h2>
              <p className="text-gray-300">
                If you have any questions about this Privacy Policy, please contact us at:
                <br />
                Email: <a href="mailto:support@universalpays.com" className="text-brand-blue hover:underline">support@universalpays.com</a>
                <br />
                Phone: <a href="tel:+13658290725" className="text-brand-blue hover:underline">+13658290725</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
